import MyCpdPage from "./pages/MyCpdPage";

const MEMBER_ROLES = ["member", "executive", "chairman", "secretary", "fellow", "firm", "past president", "probationer", "assessor", "student"];

export const cpdRoutes = [
  { path: "/my-cpd", element: <MyCpdPage />, roles: MEMBER_ROLES },
];
